import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ServerModel, Server} from './../../models/server.model';


@Component({
  selector: 'app-modal-server',
  templateUrl: './modal-server.component.html',
  styles: [`
    .modal-dialog{
      max-width:800px;
  }
  `]
})
export class ModalServerComponent implements OnInit {

  server : Server;

  formControl = new FormControl('');
  modalForm : FormGroup;

  //Manipulamos la clase modal
  private _serverModel = new ServerModel;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {

 }

 ngOnInit(){
     this.modalForm = this.fb.group({
       clave: [this.server ? this.server.clave : null],
       nombre: [this.server ? this.server.nombre : null],
       url: [this.server ? this.server.url : null],
       user: [this.server ? this.server.usuario : null],
       psw: [this.server ? this.server.password : null],
       propietario: [this.server ? this.server.propietario : null],
       fecha_vencimiento: [this.server ? this.server.fechaVencimiento : null],
       dns1:[this.server ? this.server.dns1 : null],
       dns2: [this.server ? this.server.dns2 : null],
       total: [this.server ? this.server.total : null],
       capacidad: [this.server? this.server.capacidad: null]
     });
 }

  //Agregar dominio
  adminServer(){
    this.activeModal.close('Guardado datos');
    this._serverModel.createServer(this.modalForm.value);
  }

}
